export const loadingAnimation = (show)=> {
    let loadDiv = document.getElementById("overall-situation-loading-content-id")
    if (loadDiv !== null) {
        let currentDispla = loadDiv.style.display
        // 如果当前状态和传入状态不一样才进行赋值
        if (currentDispla !== null) {
            if (show === true && currentDispla !== "flex") {
                loadDiv.style.display = "flex"
            } else {
                if (currentDispla !== "none" && show === false) {
                    loadDiv.style.display = "none"
                }
            }
        }
    }

}
